interface CreatedTravellerMatch {
  traveller: {
    id: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    created_at?: string;
  };
}

export const findCreatedTraveller = <T extends CreatedTravellerMatch>(
  travellers: T[],
  {
    email,
    firstName,
    lastName,
  }: {
    email: string;
    firstName?: string;
    lastName?: string;
  },
): T | undefined => {
  const matches = travellers.filter(
    (item) => item.traveller.email?.toLowerCase() === email.toLowerCase(),
  );

  return (
    matches.find(
      (item) =>
        item.traveller.first_name === firstName &&
        item.traveller.last_name === lastName,
    ) ??
    [...matches].sort((a, b) =>
      (b.traveller.created_at ?? '').localeCompare(
        a.traveller.created_at ?? '',
      ),
    )[0]
  );
};
